export const seoBrandCategoriesState = ({ data, component } = {}) => {
  if (!data) {
    return false;
  }

  return {
    data,
    component,
  };
};
